export default __webpack_public_path__ + "static/media/undraw_doctors_reports.9e8aa67c.svg";